import React from 'react';

/**
 * Displays a "collecting bids" indicator showing which LLM participants
 * are being queried for bids. Shown during the collection phase before
 * bid results arrive.
 *
 * @param {Array} participants - List of LLM participants being queried
 */
export function BidCollecting({ participants = [] }) {
  return (
    <div className="bid-results bid-collecting">
      <div className="bid-results-header">
        Collecting Bids
      </div>
      <div className="bid-results-list">
        {participants.length > 0 ? (
          participants.map((participant) => (
            <div key={participant.id} className="bid-result-item collecting">
              <span className="bid-participant-name">
                {participant.name}
              </span>
              <span className="bid-status-waiting">
                <span className="waiting-dots">...</span>
              </span>
            </div>
          ))
        ) : (
          <div className="bid-result-item collecting">
            <span className="bid-status-waiting">Waiting for responses...</span>
          </div>
        )}
      </div>
    </div>
  );
}
